import { Button } from '@mui/material';
import { getPOGrandTotal } from '../helper';

const POInfo = ({ poDetails, siteCode, siteName, onOk }) => {
  return (
    <div className='finance-v2-po-info-container'>
      <div className='po-info-section'>
        <span>Site Name </span>
        <span>{siteName}</span>
      </div>

      <div className='po-info-section'>
        <span>Site Code </span>
        <span>{siteCode}</span>
      </div>
      <div className='po-info-section'>
        <span>PO Number </span>
        <span>{poDetails.poNumber}</span>
      </div>
      <div className='po-info-section'>
        <span>PO Amount </span>
        <span>{getPOGrandTotal(poDetails)}</span>
      </div>
      <Button fullWidth variant='outlined' onClick={onOk} size='small'>
        Ok
      </Button>
    </div>
  );
};

export default POInfo;
